<template>
  <tml-cart
    name="main"
    @items-loaded="onItemsLoaded"
  >
    <template #heading="{title}">
      <h1 class="pt-4 lg:pt-8">
        {{ title }}
      </h1>
    </template>
    <template #right-sidebar-bottom>
      <cart-help-section />

      <tml-anchor v-if="itemsLoaded && items.length > 0" @click="saveBagToClipboard">
        <h5 class="flex items-center">
          <div>
            <font-awesome-icon
              v-if="!gettingCartRecoveryUrl"
              class="icon text-spacing h-[16px] w-[16px]"
              :icon="faShareNodes"
            />
            <tml-spinner v-else class="p-2" />
          </div>
          <span class="ml-3">
            Save bag for later
          </span>
        </h5>
      </tml-anchor>
    </template>

    <template #right-sidebar-heading="{title}">
      <h2 class="pt-8 lg:pt-8">
        {{ title }}
      </h2>
    </template>
  </tml-cart>
</template>

<script>
import {TmlCart, CartHelpSection} from '@teemill/modules/cart';
import {
  copyToClipboard,
  formatUrl,
  viewportSize,
} from '@teemill/common/helpers';
import {http, snackbar} from '@teemill/common/services';
import {faShareNodes} from '@fortawesome/pro-light-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {TmlAnchor, TmlSpinner} from '@teemill/components';

export default {
  name: 'BasketPage',

  components: {
    TmlCart,
    CartHelpSection,
    FontAwesomeIcon,
    TmlAnchor,
    TmlSpinner,
  },

  data() {
    return {
      faShareNodes,
      itemsLoaded: false,
      gettingCartRecoveryUrl: false,
      items: [],
    };
  },

  methods: {
    onItemsLoaded(items) {
      this.items = items;
      this.itemsLoaded = true;
    },
    async saveBagToClipboard() {
      this.gettingCartRecoveryUrl = true;
      const {data} = await http.get(
        formatUrl('/omnis/v3/basket/get-cart-recovery-url/')
      );

      copyToClipboard(data.url);
      this.gettingCartRecoveryUrl = false;
      snackbar('Link copied to clipboard!');
    },
  },
};
</script>

<style scoped>
.divider {
  border-bottom: 1px solid var(--tml-border-color);
}
</style>
